define.alias("shared/components/shared/wizard/slide/body", "settings/components/shared/wizard/slide/body");